import * as React from "react";

interface UserData {
  email?: string;
  name?: string;
  display_name?: string;
  hasScheduledCall?: boolean;
  login?: string;
  avatar_url?: string;
}

interface User {
  id: string;
  data: UserData;
  subscribed: boolean;
}

type UserContextType = {
  isAuthenticated: boolean;
  isLoading: boolean;
  logout: (callback: (isLoggedOut: boolean) => void) => void;
  user: User | undefined | null;
  fetchProfile: () => void;
  loginProvider: string;
  setLoginProvider: (provider: string) => void;
};

export const UserContext = React.createContext<UserContextType>({
  isAuthenticated: false,
  isLoading: true,
  user: undefined,
  logout: () => {},
  fetchProfile: () => {},
  loginProvider: "",
  setLoginProvider: () => {},
});

export const useUser = () => React.useContext(UserContext);

export type { UserContextType, User, UserData };
